import { version } from '~/package.json';

export default defineNuxtPlugin(() => {
  // eslint-disable-next-line no-restricted-properties
  console.log(
    `%cIRIS%c v${version}`,
    'background: rgb(0, 136, 123); color: white; font-weight: bold; padding: 2px 6px;',
    'background: rgb(0, 136, 123); color: black; font-weight: bold; padding: 2px 6px;'
  );
});
